import LoanArchieModuleConfiguration from "./LoanArchieModuleConfiguration";
import {LoanArchiveService} from "./service/LoanArchiveService";
import {LoanArchiveServiceName} from "../utils/names/serviceNames";

LoanArchieModuleConfiguration.createNewModule()
    .service(LoanArchiveServiceName, LoanArchiveService.instance);